export default "__VITE_ASSET__ead4e40c__"